export default {
  toasts: {
    page_not_allowed: 'u hebt geen toegang tot deze pagina',
    send_invoice_fields_required:
      'vul de ontvangers, het onderwerp en het bericht in'
  }
}
